module.exports = __webpack_public_path__ + "static/img/project-extent.fcc36e66.svg";